import type { FaireProductEntity } from "../../entity_types/product";

export const p_msreqhbzh7: FaireProductEntity = {
  token: "p_msreqhbzh7",
  type: "product",
  name: "Blonde Hinoki– HI-FI Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5b12983ab245c5181d94095f74a01b91ef11356372437860afc5408b67f3e847.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b15453c12ad565169f93ef4512384fcfa1925b39d63ae053561eb5b2af5487f8.jpeg",
    "https://cdn.faire.com/fastly/ec40e4ba6752d2f66cbd4a4d1ea2f59941c610694b461fbabded9965440ac9cb.jpeg",
    "https://cdn.faire.com/fastly/5476fc90f0bfb850c169b186eac4b679fbf7fd9671989fcbf428d18b686f15bb.jpeg",
    "https://cdn.faire.com/fastly/940c93342dc14f5e5e57daf40023f423bbab099c29e7c5f60b4f854e855cb61f.jpeg",
    "https://cdn.faire.com/fastly/0bbdc137fd1da852c6fa7b1984f0686ab4e636a6176daab6d362a28d6264b7d6.jpeg",
  ],
  priceDollars: 9.5,
  description:
    '*RESTOCKING AUGUST 2026*\n\nInspired by the light woods used to house records in a hi-fi listening bar. Clean and warm, uplifted by aromatic greenery and eucalyptus.  Golden cypress, green petitgrain, and elemi resin.\n\nPRODUCT INFORMATION:\n\nIncense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach vermilion-hued charcoal-based Incense stick is hand-dipped in California using fine fragrance oils.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours.\n\n20 sticks within a plastic sleeve and packaged into a premium drawer style box.  Each stick is approximately 7" long.',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:32.977Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
